// La logout vrem să dispară doar filtrele aplicate pe coloanele din GridComenzi (Comercial),
// NU și coloanele aduse de user prin Column Chooser (vizibilitate/ordine/lățime) — de-asta nu
// ștergem direct cheia din localStorage, ci doar câmpurile de filtrare din starea salvată.
export function clearGridComenziColumnFilters(): void {
  const raw = localStorage.getItem('grid-comenzi-state');
  if (!raw) return;
  try {
    const state = JSON.parse(raw);
    if (Array.isArray(state?.columns)) {
      state.columns.forEach((col: any) => {
        delete col.filterValue;
        delete col.filterValues;
        delete col.selectedFilterOperation;
      });
    }
    delete state.filterValue;
    delete state.filterPanel;
    delete state.searchPanel;
    localStorage.setItem('grid-comenzi-state', JSON.stringify(state));
  } catch {
    localStorage.removeItem('grid-comenzi-state');
  }
}
